import flash from 'src/setup/mixins/flashMixin'
import featureEnabled from 'src/setup/mixins/featureEnabled'
import formPost from 'src/setup/mixins/form-post'
import format from 'src/setup/mixins/format'

export default app => mixins.forEach(mixin => app.mixin(mixin))

export const mixins = [flash, formPost, featureEnabled, format]
